module.exports = __webpack_public_path__ + "static/media/ares-logo-toogle.90cd82a8.png";